import styled from "styled-components";

export const DelimiterStyled = styled.div<{ delimiterColor?: string }>`
  height: 1px;
  background-color: ${({ delimiterColor = "#ffffff" }) => delimiterColor};
`;
